import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '../../../api/requests';
import {
    OpenApiSendMessengerMessageMethod,
    type OpenApiSendMessengerMessageRequest,
    type OpenApiSendMessengerMessageResponseSuccess,
    OpenApiSendMessengerMessageUrl,
} from '../../../api/schema';

const supportChatApi = createApi({
    name: 'shared/components/SupportChat/api/api',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            sendMessengerMessage: builder.mutation<
                OpenApiSendMessengerMessageResponseSuccess,
                OpenApiSendMessengerMessageRequest
            >({
                query: (payload) => {
                    return {
                        url: OpenApiSendMessengerMessageUrl,
                        method: OpenApiSendMessengerMessageMethod,
                        body: payload,
                    };
                },
            }),
        };
    },
});

export const sendMessengerMessage = supportChatApi.endpoints.sendMessengerMessage.mutate;
